module.exports = __webpack_public_path__ + "static/media/home.a6928071.jpg";